// extracted by mini-css-extract-plugin
export default {"skeleton":"SkeletonLoader_skeleton__Kz2HL","pulse":"SkeletonLoader_pulse__YFGrn"};